import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { AdministrationService } from 'src/app/services/administration.service';
import { MatSnackBar, MatDialogRef, MatDialog, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventEntry, Event, EventEntryRider, EventClass, EventRank, EventEntryRiderClass } from 'src/app/models/eventsDto';
import { PaginationResult } from 'src/app/models/shared-models';

@Component({
  selector: 'app-event-register',
  templateUrl: './event-register.component.html',
  styleUrls: ['./event-register.component.scss']
})
export class RegisterEventComponent implements OnInit {
  eventId: number;
  userRole: string;
  event: Event;
  form: FormGroup;
  nationalUser: any;
  userId: string;
  showEditFrom: boolean;
  showResetPasswordForm: boolean;
  resetPasswordForm: any;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent, any>;
  register: EventEntry;

  riders: EventEntryRider[] = [];

  eventEntryId: number;

  rankings: EventRank[];
  rankId: number;
  classes: EventClass[];
  filterClasses: { [id: string]: EventClass[] } = { "0": [] };

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private adminService: AdministrationService,
    private snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog, private authService: AuthenticationService) { }

  ngOnInit() {
    this.eventId = +this.route.snapshot.paramMap.get('id');
    this.eventEntryId = +this.route.snapshot.paramMap.get('eventEntryId');
    this.userRole = this.authService.getUserRole();
    this.filterClasses[0] = [];
    this.sharedService.GetRanksByEventId(this.eventId).subscribe((result: PaginationResult<EventRank[]>) => {
      this.rankings = result.data;

    }, error => {

    });

    this.sharedService.GetClassesByEventId(this.eventId).subscribe((result: PaginationResult<EventClass[]>) => {
      this.classes = result.data;
      this.rankings.forEach(rank => {
        this.filterClasses[rank.id] = this.classes.filter(m => m.rankId == rank.id);

      })

    }, error => {

    });
    this.refresh();


  }

  updateForm() {
    this.form = this.fb.group({
      id: new FormControl(this.register.id),
      eventId: new FormControl(this.register.eventId),
      address: new FormControl(this.register.address, [Validators.required]),
      cellNo: new FormControl(this.register.cellNo, [Validators.required]),
      email: new FormControl(this.register.email, [Validators.required]),
      faxNo: new FormControl(this.register.faxNo, [Validators.required]),
      entryName: new FormControl(this.register.name, [Validators.required]),
      telNo: new FormControl(this.register.telNo, [Validators.required]),
      sasaInstructorName: new FormControl(this.register.sasaInstructorName),
      status: new FormControl(this.register.status),
      statusText: new FormControl(getStatusText(this.register.status)),
      club: new FormControl(this.register.club, []),
      clubNo: new FormControl(this.register.clubNo, [])
    });
    this.register.riders.forEach(m => {
      m.classes.forEach(c => {
        this.onRank(c.rankId, c, m);
      })
    })
  }

  addRider() {
    this.riders.push({
      id: 0, clubName: '', entryFee: 0, eventEntryId: 0, fluVacDate: '', fluVacNo: '',
      horseName: '', memberShipNo: '', ownerName: '', riderName: '', classes: []
    })
    this.addClass(this.riders[0])
  }

  addClass(rider: EventEntryRider) {
    rider.classes.push({ id: 0, eventClassId: 0, eventEntryRiderId: 0, rankId: 0, price: 0 });
  }

  deleteClass(cls, rider) {
    rider.classes = rider.classes.filter(m => m !== cls);
  }

  onBackClick() {
    if (this.userRole) {
      this.router.navigate(['./events/' + this.eventId]);
    }
    else {
      this.router.navigate(['./events/']);
    }

  }

  onSubmit() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    var e: EventEntry = this.form.value;
    e.riders = this.riders;
    this.sharedService.RegisterForEvent(e).subscribe(res => {
      dialogRef.close();
      //this.router.navigate([`/events/register/${this.eventId}/${res.id}`]);
      this.eventEntryId = res.id;
      this.refresh();
    }, error => {
      dialogRef.close();
      this.snackBar.open('Error submitting entry form', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  status(status) {
    this.sharedService.UpdateEventEntryStatus(this.eventEntryId, status).subscribe(m => {
      this.onBackClick();
    });
  }

  onRank(rankId: number, cls: EventEntryRiderClass, element: EventEntryRider) {
    //cls.eventClassId = 0;
    var rank = this.rankings.filter(m => m.id === rankId)[0];
    cls.price = rank.price;
    element.entryFee = element.classes.map(m => m.price).reduce((prev, next) => next + prev, 0);
    cls.rankings = this.filterClasses[cls.rankId];
  }


  refresh() {

    if (this.eventId !== -1) {
      let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      this.adminService.GetEventById(this.eventId).subscribe((result) => {
        this.event = result;
        dialogRef.close();
      }, error => {
        dialogRef.close();
      });

    }
    if (this.eventEntryId !== -1) {
      let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      this.adminService.GetEventEntryById(this.eventEntryId).subscribe((result) => {
        this.register = result;
        this.riders = this.register.riders;
        this.riders.forEach(rider =>{
          rider.classes.forEach(cl =>{
            this.onRank(cl.rankId, cl, rider);
          })
        })
        this.updateForm();
        dialogRef.close();
      }, error => {
        dialogRef.close();
      });
    } else {
      this.register = {
        id: 0,
        eventId: this.eventId,
        address: '',
        cellNo: '',
        email: '',
        faxNo: '',
        name: '',
        telNo: '',
        sasaInstructorName: '-',
        riders: this.riders,
        status: 0,
        club: '',
        clubNo: ''
      }

      this.updateForm();
      this.addRider();
    }

  }
}

function getStatusText(status: number): any {
  var text;
  switch (status) {
    case 1: text = "Accepted"; break;
    case 2: text = "Rejected"; break;
    case 3: text = "Confirmed"; break;
    default: text = "Pending"; break;
  }
  return text;
}



